import React, { useEffect, useState } from "react";
import { Autocomplete, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid2, IconButton, InputBase, Paper, Stack, Table, TableBody, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
// import SearchIcon from '@mui/icons-material/Search';
import { FaCircleChevronDown, FaIndianRupeeSign, FaPlus, FaRupeeSign } from "react-icons/fa6";
import { styled, useTheme } from '@mui/material/styles';
import TableComponent from "components/grid";
import AddIssue from "./AddIssue";
import { useDispatch } from 'store';
import { closeSnackbar, openSnackbar } from 'store/slices/snackbar';
import { useGetAllIssueQuery } from "store/slices/apis/packageSlice";
import PaginationComponent from "components/ui-components/PaginationComponent";
import { HighlightOffTwoTone } from "@mui/icons-material";
import { IoMdClose, IoMdSearch } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import EditIssue from "./EditIssue";
import { useDeleteKeyIssueMutation, useGetSubmittedByMeIssueQuery } from "store/slices/apis/keyIssueSlice";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { useDeleteKeyRiskMutation } from "store/slices/apis/keyRiskSlice";
import { usePermission } from "hooks/usePermission";
import { KEY_ISSUE_VIEW, KEY_ISSUE_DELETE } from "config";
import { ReactComponent as SearchIcon } from "assets/PwC_Funct_Icons_Search_Outline_Black_RGB.svg"
import { ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"
import { KEY_ISSUE_EDIT } from "config";

const columns = [
    {
        name: 'Issue ID',
        field: 'issueNumber',
        renderer(params) {
            return (
                <Stack direction="row" spacing={1}>
                    {params?.issueNumber &&
                        <Chip label={params?.issueNumber} size="small" sx={{
                            fontSize: '12px',
                            '& .MuiChip-label': {
                                paddingLeft: '8px',
                                paddingRight: '8px',
                                fontWeight: 600
                            }
                        }} />
                    }
                </Stack>
            );
        }
    },
    {
        name: 'Consultant/Contractor',
        field: 'contractor',
    },
    {
        name: 'Category',
        field: 'package',
    },
    {
        name: 'Issue description',
        field: 'issueDescription',
    },
    {
        name: 'Reported date',
        field: 'reportedDate',
        renderer(params) {
            return (
                <>
                    {params?.reportedDate
                        ? moment(params.reportedDate).format("DD/MM/YY")
                        : "N.A."}
                </>
            );
        },
    },
    {
        name: 'Workflow status',
        field: 'workflowStatus',
    },
    {
        name: 'Current status',
        field: 'currentStatus',
    },
    {
        name: "Created Date",
        field: "createdDate",
        renderer(params) {
            return (
                <>
                    {params?.createdDate
                        ? moment(params.createdDate).format("DD/MM/YY")
                        : "N.A."}
                </>
            );
        },
    },
    {
        name: 'Actions required by',
        field: 'actionRequiredBy',
    },
    {
        name: 'Actions required by email',
        field: 'actionRequiredByEmail',
    },
    {
        name: 'Time impact (Days)',
        field: 'timeImpact',
    },
    {
        name: 'Cost impact',
        field: 'costImpact',
        renderer(params) {
            return (

                <Stack direction="row" spacing={1}>
                    {params?.costImpact ?
                        <Chip icon={<FaIndianRupeeSign />} label={params?.costImpact} sx={{
                            backgroundColor: '#3E756D',
                            color: '#fff',
                            fontSize: '12px',
                            height: '18px',
                            '& .MuiChip-icon': {
                                color: '#fff'
                            },
                            '& .MuiChip-label': {
                                paddingLeft: '8px',
                                paddingRight: '8px'
                            }
                        }} />
                        : <Chip label="N/A" size="small" sx={{
                            fontSize: '12px',
                            '& .MuiChip-label': {
                                paddingLeft: '8px',
                                paddingRight: '8px'
                            }
                        }} />
                    }

                </Stack>
            );
        }
    },
    {
        name: 'Action',
        field: 'action',
        option: {}
    },
];

const currentStatuses = [
    { label: "Open", year: 1994 },
    { label: "Close", year: 1972 }
];

const SubmittedByMe = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const viewAccess = usePermission(KEY_ISSUE_VIEW);
    const editAccess = usePermission(KEY_ISSUE_EDIT);
    const deleteAccess = usePermission(KEY_ISSUE_DELETE)

    const [showAddIssue, setShowAddIssue] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [deleteItem, setDeleteItem] = useState(null);
    const [isDeleteModal, setDeleteModal] = useState(false);

    // filter data
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [currentStatus, setCurrentStatus] = useState('');

    const [filters, setFilters] = useState({
        fromDate: '',
        toDate: '',
        currentStatus: '',
    });

    // Edit model state
    const [isEditIssueModal, setEditIssueModal] = useState(false);
    const [issueData, setEditIssueData] = useState(null);

    // View model state
    const [isViewIssueModal, setIsViewIssueModal] = useState(false);

    const { projectId } = useParams();
    const { data: getSubmittedByMeIssue, isLoading } = useGetSubmittedByMeIssueQuery({
        projectId,
        page: pageNumber,
        fromDate: filters?.fromDate,
        toDate: filters?.toDate,
        currentStatus: filters?.currentStatus,
    });
    const [issueDeleteFn, issueDeleteRes] = useDeleteKeyRiskMutation();
    // console.log(allIssues?.data?.issues);

    const dispatch = useDispatch();

    const handleAddIssue = () => {
        setShowAddIssue(!showAddIssue);
    }
    const CustomCalendarIcon = (props) => (
        <CalendarIcon {...props} style={{ width: 22, height: 22, fill: "#696969 ", stroke: "#696969", strokeWidth: 4 }} />
    );

    const openNotification = async (msg, type = 'error') => {

        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );

        setTimeout(() => dispatch(closeSnackbar()), 3000);

    };

    const handleActionEdit = (row) => {
        setEditIssueModal(!isEditIssueModal)
        if (!issueData) {
            setEditIssueData(row);
        } else {
            setEditIssueData(null);
        }

    }

    const encrypt = (text) => btoa(unescape(encodeURIComponent(text)));

    const handleActionView = (row) => {
        const encrypted = encrypt("view");
        navigate(`/projects/${projectId}/issue-detail/${row?.id}/${encrypted}/false`);
        // setIsViewIssueModal(!isViewIssueModal)
        // if (!issueData) {
        //     setEditIssueData(row);
        // } else {
        //     setEditIssueData(null);
        // }

    }
    const handleActionDelete = (row) => {
        setDeleteItem(row);
        setDeleteModal(true);
    }

    const handleConfirmationDelete = () => {
        issueDeleteFn(deleteItem?.id)
    }

    useEffect(() => {
        if (issueDeleteRes?.isSuccess) {
            if (issueDeleteRes?.data?.status == 'Success') {
                openNotification(issueDeleteRes?.data?.message, 'success')
            } else {
                openNotification(issueDeleteRes?.data?.message, 'error')
            }
            handleCloseDelete();
        }
    }, [issueDeleteRes?.isSuccess]);

    const handleCloseDelete = () => {
        setDeleteItem(null);
        setDeleteModal(false);
    }

    const confirmationDeleteDialog = () => (
        <Dialog
            open={isDeleteModal}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle sx={{ fontWeight: 500, fontSize: '20px', color: '#252525', paddingBottom: 0 }} id="draggable-dialog-title">
                Delete
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleCloseDelete}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                {/* <IoMdClose style={{ fontSize: '20px' }} /> */}
                <CrossIcon style={{ fontSize: "20px", width: "20px", height: "20px" }} />
            </IconButton>
            <DialogContent>
                <DialogContentText sx={{ fontWeight: 400, fontSize: '16px', color: '#474747' }}>
                    Are you sure you want to Delete this issue? This action is permanent.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {/* <Button variant="outlined" onClick={handleCloseDelete} sx={{
                    color: '#415385',
                    fontSize: '16px',
                    fontWeight: '500',
                    textTransform: 'none',
                    border: '1px solid #415385'
                }}>Cancel</Button> */}
                <Button onClick={handleConfirmationDelete} loading={issueDeleteRes?.isLoading} variant="contained" sx={{
                    backgroundColor: '#C52A1A',
                    color: '#fff',
                    fontSize: '16px',
                    fontWeight: '500',
                    textTransform: 'none'
                }}>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );

    // const processedColumns = columns.map((col) => {
    //     if (col.field === "action") {
    //         const deleteOrEdit = getSubmittedByMeIssue?.data?.issues?.some(
    //             (issue) => issue.currentStatus?.toLowerCase() !== "close"
    //         )
    //         return {
    //             ...col,
    //             option: {
    //                 ...col.option,
    //                 delete: deleteOrEdit,
    //                 edit: deleteOrEdit,
    //             },
    //         };
    //     }
    //     return col;
    // });

    return (
        <>
            {confirmationDeleteDialog()}
            <Grid2 container spacing={2} sx={{ mt: '20px' }}>
                <Grid2 size={12}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        gap: 2,
                        flexWrap: 'wrap',
                    }}>
                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            sx={{
                                flexGrow: 1,
                                flexWrap: 'wrap',
                                alignItems: { xs: 'stretch', sm: 'center' },
                                gap: { xs: 1, sm: 2 },
                                width: { xs: '100%', sm: 'auto' }
                            }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} size="small">
                                <DemoContainer components={['DatePicker', 'DatePicker']}>
                                    <DatePicker
                                        label="From Date"
                                        value={fromDate}
                                        format="DD-MM-YYYY"
                                        onChange={(newValue) => setFromDate(newValue)}
                                        slots={{
                                            openPickerIcon: CustomCalendarIcon,
                                        }}
                                        slotProps={{
                                            textField: {
                                                sx: { minWidth: 150 },
                                                size: 'small'
                                            }
                                        }}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker', 'DatePicker']}>
                                    <DatePicker
                                        label="To Date"
                                        value={toDate}
                                        format="DD-MM-YYYY"
                                        onChange={(newValue) => setToDate(newValue)}
                                        slots={{
                                            openPickerIcon: CustomCalendarIcon,
                                        }}
                                        slotProps={{
                                            textField: {
                                                sx: { minWidth: 150 },
                                                size: "small"
                                            }
                                        }}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                            {/* <DatePicker
                                selectsRange
                                startDate={fromDate}
                                endDate={toDate}
                                onChange={(dates) => {
                                    const [start, end] = dates;
                                    setFromDate(start);
                                    setToDate(end);
                                }}
                                isClearable
                                placeholderText="Select date range"
                                customInput={
                                    <TextField
                                        label="Date Range"
                                        name="currentStatus"
                                        slotProps={{ inputLabel: { shrink: true } }}
                                        variant="filled"
                                        size="small"
                                        sx={{
                                            '& .MuiFilledInput-root': {
                                                backgroundColor: '#fff'
                                            }
                                        }}
                                    />
                                }
                            /> */}
                            <Autocomplete
                                options={currentStatuses}
                                getOptionLabel={(option) => option?.label}
                                onChange={(_, newValue) => setCurrentStatus(newValue ? newValue?.label : '')}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Current Status"
                                        name="currentStatus"
                                        // slotProps={{ inputLabel: { shrink: true } }}
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                            '& .MuiFilledInput-root': {
                                                backgroundColor: '#fff'
                                            }
                                        }}
                                    />
                                )}
                                ListboxProps={{
                                    sx: { fontSize: "13px" },
                                }}
                                sx={{ width: { xs: '100%', sm: '23%' }, marginTop: '7px !important' }} // Adjust width
                            />
                            <Button
                                loading={isLoading}
                                onClick={() => {

                                    setFilters({
                                        fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : '',
                                        toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : '',
                                        currentStatus,
                                    });
                                    // refetch();
                                }}
                                size="medium"
                                startIcon={
                                    // <IoMdSearch />
                                    <SearchIcon style={{ height: "20px", width: "20px", fill: `${theme?.customSettings?.themeColor}` }} />
                                }
                                variant='outlined' sx={{
                                    color: `${theme?.customSettings?.themeColor}`,
                                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                                    background: 'none',
                                    textTransform: 'inherit'
                                }}>
                                Search
                            </Button>
                        </Stack>
                        {/* <Paper
                            component="form"
                            sx={{ display: 'flex', alignItems: 'center' }}
                        >
                            <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                                <SearchIcon sx={{ fontSize: '20px' }} />
                            </IconButton>
                            <InputBase
                                sx={{ ml: 1, flex: 1, fontSize: '16px', color: '#696969' }}
                                placeholder="Search"
                                inputProps={{ 'aria-label': 'search google maps' }}
                            />
                        </Paper>
                        <Button variant="contained" onClick={handleAddIssue} startIcon={<FaPlus />} sx={{
                            backgroundColor: `${theme?.customSettings?.themeColor}`, color: '#FFF', padding: '6px 20px', fontWeight: '500', textTransform: 'none', fontSize: '16px'
                        }}>
                            Add Issue
                        </Button> */}
                    </Box>
                </Grid2>
                <Grid2 size={12} sx={{ mt: 2 }}>
                    <TableComponent
                        columns={columns
                            .map((col) =>
                                col.field === "action"
                                    ? {
                                        ...col,
                                        option: {
                                            ...col.option,
                                            view: viewAccess,
                                            // edit: editAccess,
                                            delete: deleteAccess
                                        },
                                    }
                                    : col
                            )
                            .filter((col) => {
                                if (col.field !== "action") {
                                    return true;
                                } else {
                                    return Object.values(col.option).some((v) => v === true);
                                }

                            })}
                        data={getSubmittedByMeIssue?.data?.issues}
                        actionDelete={handleActionDelete}
                        actionEdit={handleActionEdit}
                        actionView={handleActionView}
                        isLoading={isLoading}
                    />
                    {!isLoading && (
                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                            <PaginationComponent
                                pageNumber={getSubmittedByMeIssue?.data?.page || 1}
                                totalPages={Math.ceil(getSubmittedByMeIssue?.data?.totalRecords / getSubmittedByMeIssue?.data?.pageSize) || 1}
                                onPageChange={setPageNumber}
                            />
                        </Box>
                    )}
                </Grid2>
            </Grid2>

            {showAddIssue &&
                <AddIssue cancelIssue={handleAddIssue} open={showAddIssue} openNotification={openNotification} />
            }
            {/* Here Dialog box for edit  issue */}
            {isEditIssueModal &&
                <EditIssue cancelIssue={handleActionEdit} open={isEditIssueModal} data={issueData} openNotification={openNotification} />
            }

            {isViewIssueModal &&
                <EditIssue cancelIssue={handleActionView} open={isViewIssueModal} data={issueData} openNotification={openNotification} isViewIssueModal />
            }
        </>
    );
};

export default SubmittedByMe;